import React, { useState, useEffect } from 'react';

import useUserStore from '@lcsc-ui/store/user';
import Domains from '@lcsc-ui/utils/domains';
import lcMsgTips from '@lcsc-ui/utils/lcMsgTips';
import sendAxios from '@lcsc-ui/utils/request';
import Utils from '@lcsc-ui/utils/Utils';
import { Modal, Button, message } from 'antd';

import DialogLeft from './components/dialogLeft';
import DialogRight from './components/dialogRight';

import API from '@/asyncApi/home';

const activityTypeSpmMap = {
  stockpile: 'stk',
  push_material: 'lt',
  hot: 'hot',
  discount: 'zk',
  clearance: 'qc',
  rebate: 'fl',
  mro_hot: 'mro',
};

export default function GoBuyDialog({ row, productId, entryType, isModalOpen, setIsModalOpen }) {
  const { userInfo, updateUserInfo } = useUserStore();
  const fromZone = useUserStore((state) => state.fromZone);
  const [isOpen, setIsOpen] = useState(isModalOpen);
  const [productInfo, setProductInfo] = useState(row);
  const [childValue, setChildValue] = useState(row?.ratio || 1);
  const [loading, setLoading] = useState(false);
  const dataObj = {
    productId: productId,
    cartPrice: 0,
    cartTotalPrice: 0,
    ratio: 1,
    minEncapsulationNumber: 0,
    validStockNumber: 0,
    sampleStockNumber: 0,
    batchStockLimit: 0,
    batchStockNumber: 0,
    hasSampleRule: false,
    productPriceList: [], // 数量与价格的对应
    oversea: false, //
    entryType: entryType || '',
    productCode: '',
  };
  useEffect(() => {
    setIsOpen(isModalOpen);
    setProductInfo(row);
  }, [isModalOpen]);

  const handleOk = (event) => {
    const { lcsc_vid = '', spm = '' } = Utils.getButtonParams(event.currentTarget);
    let number = childValue;
    if (number < row?.ratio) {
      number = row?.ratio;
    } else if (number % row?.ratio !== 0) {
      number = Number(row?.ratio) * Math.ceil(number / row?.ratio);
    }

    if (number / row?.ratio < 1 || number % row?.ratio !== 0) {
      return;
    }
    if (!row.szValidStockNumber && !row.jsValidStockNumber) {
      lcMsgTips.showConfirmModal({
        title: '抱歉，该商品暂无库存',
      });
      return;
    }
    const str = '0~' + dataObj.productId + '~' + number / row?.ratio;
    // 正常普通加购
    const url = API.cartAddNormal;
    const data = {
      cartKeyStr: str,
      entryType: 'home_page',
      trackZone: fromZone,
      lcscVid: lcsc_vid,
      spm,
    };
    sendAxios({
      method: 'post',
      data,
      url,
      baseURL: Domains.lcscCartApiUrl,
    })
      .then((res) => {
        if (res.needLogin) {
          gotoLogin();
          return;
        }
        if (res?.result?.shifting) {
          lcMsgTips.showConfirmModal({
            title: res?.result?.shifting,
          });
        } else if (res?.msg && res?.msg.indexOf('needLogin') >= 0) {
          window.location.href = '/login.html';
        } else if (res?.code === 200) {
          message.success('加入购物车成功！');
          updateUserInfo({ ...userInfo, cartNum: res?.result?.cart_contains_count });
          // setIsModalOpen(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // 跳登录和注册
  const gotoLogin = (type) => {
    const url = Utils.getCasTypeUrl(type);
    window.open(url, '_self');
  };
  const handleCancel = () => {
    setIsOpen(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        centered
        width="800px"
        title="添加购物车"
        cancelText=""
        open={isOpen}
        onCancel={handleCancel}
        footer={[
          <Button
            key="submit"
            data-spm={`${activityTypeSpmMap[row.dialogRightProps.activityType]}.had`}
            type="primary"
            danger
            onClick={handleOk}
            loading={loading}
          >
            {productInfo?.hasStockNow ? '加入购物车' : '我要订货'}
          </Button>,
        ]}
      >
        <div className="flex text-[14px]">
          <DialogLeft row={productInfo} />
          <DialogRight
            row={productInfo}
            setParentValue={(e) => setChildValue(e)}
            dialogRightProps={row?.dialogRightProps}
          />
        </div>
      </Modal>
    </>
  );
}
